// Central feature gating — single source of truth.
// Phase 1: only the participant cap is enforced.

export type Tier = "free" | "pro" | "team";

export const LIMITS = {
  free: { maxPlayers: 30 },
  pro: { maxPlayers: 200 },
  team: { maxPlayers: 500 },
} as const;

export function maxPlayersFor(tier: Tier | null | undefined): number {
  return LIMITS[tier ?? "free"].maxPlayers;
}

export function canFeature(
  tier: Tier | null | undefined,
  feature: "session_history" | "branding" | "ai_trivia" | "jira_sync",
): boolean {
  const t = tier ?? "free";
  switch (feature) {
    case "session_history":
      return t !== "free";
    case "branding":
      return t === "team";
    case "ai_trivia":
      return t !== "free";
    case "jira_sync":
      return t !== "free";
  }
}
